var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBaloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40249 4.48882C8.33182 6.70194 9.61677 10.3878 10.7008 12.7894C10.8274 13.07 10.9378 13.3145 11.0425 13.5286L8.76283 14.2885C8.36987 14.4195 8.1575 14.8442 8.28849 15.2372C8.41947 15.6301 8.84421 15.8425 9.23717 15.7115L10.5881 15.2612C9.84066 16.2668 8.97821 17.2946 8.02922 18.2103C6.17825 19.9963 4.10834 21.25 2 21.25C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75C4.69166 22.75 7.12175 21.1704 9.07078 19.2897C10.1282 18.2694 11.0767 17.1291 11.8858 16.0292L12.2885 17.2372C12.4195 17.6301 12.8442 17.8425 13.2372 17.7115C13.6301 17.5805 13.8425 17.1558 13.7115 16.7628L13.1228 14.9967C13.4577 14.9811 13.8488 14.9122 14.3553 14.8231C16.8104 14.3908 20.3601 13.3953 21.4308 11.1821C23.2194 7.48496 20.5793 4.26389 16.4913 5.61398C15.1668 1.252 11.1911 0.791633 9.40249 4.48882Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBaloon);
export default __webpack_public_path__ + "static/media/heart-baloon.cbf2c505c5e41bb695ef3af5b75ab93c.svg";
export { ForwardRef as ReactComponent };